// インタラクティブ背景グラデーション（マウス追従、元: brand/sustainability/contents/_kv.php 内 #main-canvas-interactive）
// brand/sustainability で使用。
// 使用する要素: <canvas id="main-canvas-interactive"></canvas>
// 動的な値は無し（色・パラメータは固定値）。
(function () {
  function init() {
    const canvas = document.getElementById('main-canvas-interactive');
    if (!canvas) return;

    const ctx = canvas.getContext('2d', {
      willReadFrequently: false,
      alpha: false
    });

    // マウス位置
    let mouseX = 0.5;
    let mouseY = 0.5;
    let targetMouseX = 0.5;
    let targetMouseY = 0.5;

    // グラデーション色（#CCCCCCと#FFFFFF）
    const colors = [{
        r: 255,
        g: 255,
        b: 255,
        x: 0.5,
        y: 0.5
      }, // #FFFFFF
      {
        r: 204,
        g: 204,
        b: 204,
        x: 0.3,
        y: 0.3
      }, // #CCCCCC
      {
        r: 255,
        g: 255,
        b: 255,
        x: 0.7,
        y: 0.3
      }, // #FFFFFF
      {
        r: 204,
        g: 204,
        b: 204,
        x: 0.7,
        y: 0.7
      }, // #CCCCCC
      {
        r: 255,
        g: 255,
        b: 255,
        x: 0.3,
        y: 0.7
      }, // #FFFFFF
      {
        r: 204,
        g: 204,
        b: 204,
        x: 0.5,
        y: 0.2
      }, // #CCCCCC
      {
        r: 255,
        g: 255,
        b: 255,
        x: 0.2,
        y: 0.5
      }, // #FFFFFF
      {
        r: 204,
        g: 204,
        b: 204,
        x: 0.8,
        y: 0.5
      }, // #CCCCCC
      {
        r: 255,
        g: 255,
        b: 255,
        x: 0.5,
        y: 0.8
      }, // #FFFFFF
      {
        r: 204,
        g: 204,
        b: 204,
        x: 0.4,
        y: 0.6
      }, // #CCCCCC
      {
        r: 255,
        g: 255,
        b: 255,
        x: 0.6,
        y: 0.4
      }, // #FFFFFF
      {
        r: 204,
        g: 204,
        b: 204,
        x: 0.35,
        y: 0.45
      } // #CCCCCC
    ];

    let blobs = [];

    // パラメータ
    let params = {
      numColors: 12,
      flowSpeed: 1.4,
      waveSpeed: 1.95,
      blobRadius: 0.65,
      mouseInfluence: 0.85,
      mouseRadius: 0.2,
      smoothing: 0.09
    };

    // 中央の避ける領域
    let avoidZone = {
      x: 0.5,
      y: 0.5,
      radius: 0.2
    };

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();

    function initBlobs() {
      blobs = [];
      for (let i = 0; i < colors.length; i++) {
        const color = colors[i];
        blobs.push({
          x: color.x,
          y: color.y,
          originalX: color.x,
          originalY: color.y,
          radius: params.blobRadius,
          colorIndex: i,
          phase: Math.random() * Math.PI * 2,
          speed: 0.5 + Math.random() * 0.5,
          scaleX: 1,
          scaleY: 1,
          rotation: Math.random() * Math.PI * 2,
          deformPhase: Math.random() * Math.PI * 2
        });
      }
    }

    // マウス移動イベント
    document.addEventListener('mousemove', (e) => {
      targetMouseX = e.clientX / window.innerWidth;
      targetMouseY = e.clientY / window.innerHeight;
    });

    function drawOrganicGradient(time = 0) {
      ctx.globalCompositeOperation = 'source-over';

      // 背景を最初の色で塗る
      ctx.fillStyle = `rgb(${colors[0].r}, ${colors[0].g}, ${colors[0].b})`;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // マウス位置をスムーズに補間
      mouseX += (targetMouseX - mouseX) * params.smoothing;
      mouseY += (targetMouseY - mouseY) * params.smoothing;

      // 各blobを更新して描画
      for (let i = 0; i < blobs.length; i++) {
        const blob = blobs[i];
        const flowSpeed = params.flowSpeed;
        const waveSpeed = params.waveSpeed;

        // メインの流れ
        const flowX = Math.sin(time * flowSpeed * 0.3 + blob.phase) * 0.25;
        const flowY = Math.cos(time * flowSpeed * 0.25 + blob.phase * 1.3) * 0.25;

        // 小さな波
        const waveX = Math.sin(time * waveSpeed * 2 + blob.phase * 2) * 0.08;
        const waveY = Math.cos(time * waveSpeed * 1.7 + blob.phase * 2.5) * 0.08;

        // 回転
        const rotation = time * 0.05;
        let rotX = Math.cos(rotation + blob.phase) * 0.15;
        let rotY = Math.sin(rotation + blob.phase) * 0.15;

        // 基本位置
        let targetX = blob.originalX + flowX + waveX + rotX;
        let targetY = blob.originalY + flowY + waveY + rotY;

        // マウスの影響を追加
        const dx = targetX - mouseX;
        const dy = targetY - mouseY;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < params.mouseRadius) {
          // マウスに近いblobは押し出される
          const pushForce = (params.mouseRadius - dist) / params.mouseRadius;
          const influence = params.mouseInfluence * pushForce;
          targetX += (dx / dist) * influence;
          targetY += (dy / dist) * influence;
        }

        // 中央のテキストを避ける
        if (avoidZone.radius > 0) {
          const dxAvoid = targetX - avoidZone.x;
          const dyAvoid = targetY - avoidZone.y;
          const distAvoid = Math.sqrt(dxAvoid * dxAvoid + dyAvoid * dyAvoid);

          if (distAvoid < avoidZone.radius) {
            const pushForce = (avoidZone.radius - distAvoid) / avoidZone.radius;
            targetX += (dxAvoid / distAvoid) * pushForce * 0.3;
            targetY += (dyAvoid / distAvoid) * pushForce * 0.3;
          }
        }

        blob.x = targetX;
        blob.y = targetY;

        // 有機的な形状変化
        blob.scaleX = 1 + Math.sin(time * 0.3 + blob.deformPhase) * 0.4;
        blob.scaleY = 1 + Math.cos(time * 0.25 + blob.deformPhase * 1.3) * 0.4;
        blob.rotation = time * 0.1 + blob.phase;

        // グラデーションを描画
        const x = blob.x * canvas.width;
        const y = blob.y * canvas.height;

        const baseRadius = blob.radius * Math.max(canvas.width, canvas.height);
        const sizeVariation = 1 + Math.sin(time * 0.4 + blob.phase) * 0.2;

        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(blob.rotation);
        ctx.scale(blob.scaleX, blob.scaleY);

        const color = colors[i % colors.length];
        const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, baseRadius * sizeVariation);

        gradient.addColorStop(0, `rgba(${color.r}, ${color.g}, ${color.b}, 0.8)`);
        gradient.addColorStop(0.4, `rgba(${color.r}, ${color.g}, ${color.b}, 0.6)`);
        gradient.addColorStop(0.7, `rgba(${color.r}, ${color.g}, ${color.b}, 0.3)`);
        gradient.addColorStop(1, `rgba(${color.r}, ${color.g}, ${color.b}, 0)`);

        ctx.fillStyle = gradient;
        ctx.fillRect(-baseRadius * 2, -baseRadius * 2, baseRadius * 4, baseRadius * 4);

        ctx.restore();
      }
    }

    function animate() {
      const time = Date.now() * 0.001;

      drawOrganicGradient(time);

      requestAnimationFrame(animate);
    }

    initBlobs();
    animate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
